export default (function (templateString, vars) {
    return templateString.replace(/\${(\w+)}/g, function (match, p1) { return (vars[p1] ? String(vars[p1]) : ''); });
});
//# sourceMappingURL=interpolate.js.map